import Router, {NavigationGuardNext, Route} from 'vue-router'
import DashboardComponent from '../components/dashboard.vue';
import account from '../components/account.vue';
import store from '../store/store';
import {RouterOptions, RouteConfig} from 'vue-router';
import PageNotFoundComponent from "../components/page-not-found.vue";
import AdminComponent from "../components/admin.vue";
import ScriptGeneratorComponent from "../components/script-generator.vue";
import {ClientService} from "../services/client.service";
import PermissionDeniedComponent from "../components/permission-denied.vue";

const navRoutes = <Array<RouteConfig>>[
    {
        path: '/',
        name: 'dashboard',
        component: DashboardComponent,
    },
    {
        path: '/account',
        name: 'account',
        component: account,
    },
    {
        path: '/admin',
        name: 'admin',
        component: AdminComponent,
    },
    {
        path: '/generator',
        name: 'generator',
        component: ScriptGeneratorComponent,
    },
    {
        path: '/generator/:id',
        name: 'generator',
        component: ScriptGeneratorComponent,
    },
    {
        path: '/permission-denied',
        name: 'permission-denied',
        component: PermissionDeniedComponent,
    },
    {
        path: "*",
        component: PageNotFoundComponent
    }
];

let router = new Router(<RouterOptions>{
    routes: navRoutes
});

router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
    if(to.name === 'permission-denied') {
        return next();
    }
    next();
});

export default router;
